/**
 * DataTypeToggle Component
 * 
 * Toggle component for switching between salary (給与) and bonus (賞与) data types.
 * Used in office employee data display to switch between viewing salary and bonus records.
 * 
 * Features:
 * - Two toggle buttons (Salary/Bonus)
 * - Active state highlighting
 * - Single callback for both buttons (toggles on click)
 * 
 * Used in office employee and construction worker data display to switch between
 * 給与データ and 賞与データ.
 * 
 * @component
 */

import React from 'react';
import { DataType } from './types/DataDisplayTypes';

/**
 * Props interface for DataTypeToggle component.
 */
interface DataTypeToggleProps {
  dataType: DataType;           // Current data type ('salary' or 'bonus')
  onToggle: () => void;         // Callback function when toggle is clicked
}

/**
 * DataTypeToggle Component
 * 
 * Renders two toggle buttons for switching between salary and bonus data types.
 * The active button is highlighted based on the current dataType prop.
 * Both buttons call the same onToggle callback.
 * 
 * @param props - Component props
 * @returns React functional component
 */
export const DataTypeToggle: React.FC<DataTypeToggleProps> = ({
  dataType,
  onToggle
}) => {
  return (
    <div className="data-type-toggle">
      {/* Salary (給与) Data Toggle Button */}
      <button 
        className={`toggle-btn ${dataType === 'salary' ? 'active' : ''}`}
        onClick={onToggle}
      >
        給与データ
      </button>
      
      {/* Bonus (賞与) Data Toggle Button */}
      <button 
        className={`toggle-btn ${dataType === 'bonus' ? 'active' : ''}`}
        onClick={onToggle}
      >
        賞与データ
      </button>
    </div>
  );
}; 